var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomParagraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 69,
    viewBox: "0 0 77 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.258789,
    y: 0.509766,
    width: 76.4828,
    height: 67.8893,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2793,
    y: 59.8984,
    width: 14.0362,
    height: 60.155,
    transform: "rotate(-90 8.2793 59.8984)",
    fill: "#F1F3F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2793,
    y: 40.9697,
    width: 14.0362,
    height: 60.155,
    transform: "rotate(-90 8.2793 40.9697)",
    fill: "#F1F3F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2793,
    y: 22.041,
    width: 14.0362,
    height: 60.155,
    transform: "rotate(-90 8.2793 22.041)",
    fill: "#F1F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomParagraph);
export default __webpack_public_path__ + "static/media/CustomParagraph.066e008433c08f073ad6002f24c1cec3.svg";
export { ForwardRef as ReactComponent };